var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { DraftLayout } from './components/layout/DraftLayout';
import { DraftStage_Scenes } from './components/DraftStage_Scenes';
import { runtime } from '../../classes/runtime/Runtime';
import './DraftStage.css';
let DraftStage_ = class DraftStage_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (runtime.isServerRuntime) {
            return null;
        }
        return (React.createElement(DraftLayout, { app: app },
            React.createElement(DraftStage_Scenes, { app: app })));
    }
};
DraftStage_ = __decorate([
    observer
], DraftStage_);
export { DraftStage_ };
